import * as React from 'react';

import { createStackNavigator } from '@react-navigation/stack';
import FormTemplateScreen from '../screens/form-template/FormTemplateScreen';
import { getScreenOptions } from './getScreenOptions';
import StudyEventFormScreen from '../screens/study/StudyEventFormScreen';
import { DrawerParamList } from './DrawerNavigator';
import ToDoScreen from '../screens/to-do/ToDoScreen';
import AppHeader from '../components/AppHeader';

export type TodoParamList = {
  ToDo: undefined;
  FormTemplate: DrawerParamList['FormTemplate'];
  StudyEventForm: {
    entityDataId?: number;
    path?: string;
    sectionIndex?: number;
    backAnimation?: boolean;
    studyParticipantId: number;
    participantEventId: number;
    participantEventLogId?: number;
    occurrenceCount: number;
  };
};

const ToDoStack = createStackNavigator<TodoParamList>();

export default function ToDoNavigator() {
  return (
    <ToDoStack.Navigator
      initialRouteName='ToDo'
      screenOptions={({ route }) => ({
        ...getScreenOptions(route),
        header: () => <AppHeader />,
        headerMode: 'float',
        headerShown: true,
        gestureEnabled: false
      })}
    >
      <ToDoStack.Screen name='ToDo' component={ToDoScreen} />
      <ToDoStack.Screen name='FormTemplate' component={FormTemplateScreen} />
      <ToDoStack.Screen
        name='StudyEventForm'
        component={StudyEventFormScreen}
      />
    </ToDoStack.Navigator>
  );
}
